<div class="select-domain-container">
  <div mat-dialog-title class="select-domain__header">
    <span>Select domain</span>
    <span class="select-domain__close" (click)="closeDialog()">
      <img class="themified-white-icon select-domain__close-icon" src="/assets/icons/cross-icon.png">
    </span>
  </div>
  <div mat-dialog-content class="select-domain__content">
    <mat-form-field class="custom-mat-form-field select-domain__list">
      <mat-label>Domain</mat-label>
      <img matSuffix class="custom-mat-autocomplete__arrow-icon" src="/assets/icons/chevron-down-icon.png">
      <mat-select [(ngModel)]="currentDomain">
        <mat-option *ngFor="let domain of domains" [value]="domain" class="cust-mat-option">
          <span title="{{domain.domainName}}">{{domain.domainName}}</span>
        </mat-option>
      </mat-select>
    </mat-form-field>
    <button mat-button class="btn btn_accent-gradient-rounded select-domain__submit-btn" (click)="confirm()" ubi-round-button>
      Submit
    </button>
  </div>
</div>
